import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import TranslationProvider, { getTranslation } from '../../../providers/TranslationProvider';
import { postAuthMobile, postAuthMobileClaim } from '../../../api/api';
import './UpdatePhoneView.scss';
import InputCode from './InputCode';
import { AuthAnalyticsEvents, SmsVerificationMethods } from '../../../containers/AuthContainer/authSteps';

const VerifyPhone = (props) => {
  const { verificationComplete, phoneNumber, Analytics } = props;
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState(null);

  const resendCode = async () => {
    setError(null);
    setProcessing(true);

    try {
      await postAuthMobile({
        mobile_number: phoneNumber,
        device_type_id: 3,
        method: 'sms',
        captcha_token: null,
      });
      setProcessing(false);
    } catch (err) {
      setProcessing(false);
    }
  };

  const submitClaimToken = async (claim) => {
    setProcessing(true);
    try {
      await postAuthMobileClaim({
        mobile_number: phoneNumber,
        claim_token: claim,
      });
      setProcessing(false);
      verificationComplete();
    } catch (e) {
      setProcessing(false);
      setError(getTranslation({ translationKey: 'code_input_error', fallback: 'Oops, that didn’t work. Please enter the code that was sent to you.' }));
    }
  };

  const submitCode = async (otp) => {
    setError(null);
    setProcessing(true);
    let response;
    try {
      response = await postAuthMobile({
        mobile_number: phoneNumber,
        code: otp,
      });
      setProcessing(false);
      if (response?.mobile_claim?.claim_token) {
        submitClaimToken(response.mobile_claim.claim_token);
        Analytics.event(AuthAnalyticsEvents.ENTER_SMS, {
          method: SmsVerificationMethods.PROFILE,
        });
      } else {
        setError(getTranslation({ translationKey: 'code_input_error', fallback: 'Oops, that didn’t work. Please enter the code that was sent to you.' }));
      }
    } catch (err) {
      setProcessing(false);
      const errorMessage = getTranslation({ translationKey: 'code_input_error', fallback: 'Oops, that didn’t work. Please enter the code that was sent to you.' });
      setError(err?.data?.data?.code || errorMessage);
    }
  };

  const phoneObj = parsePhoneNumberFromString(phoneNumber || '');
  return (
    <>
      <div
        role="alert"
      >
        <TranslationProvider
          translationKey="mobile_number_verification_title"
        >
          <div className="UpdatePhoneView__Headline" style={{ marginBottom: '20px' }}>
            We sent you a code
          </div>
        </TranslationProvider>
        <div
          className="UpdatePhoneView__Text--light"
        >
          <TranslationProvider
            translationKey="mobile_number_verification_desc"
            translationValues={{ phoneNumber: `+${phoneObj?.countryCallingCode} ${phoneObj?.formatNational()}` }}
          >
            <span>
              We sent a 6-digit confirmation code to
              {`+${phoneObj?.countryCallingCode} ${phoneObj?.formatNational()}`}
              . It expires shortly, so enter it soon.
            </span>
          </TranslationProvider>
        </div>
      </div>
      <InputCode onComplete={submitCode} processing={processing} error={error} onResend={resendCode} />
    </>
  );
};

VerifyPhone.propTypes = {
  phoneNumber: PropTypes.string,
  verificationComplete: PropTypes.func.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
    page: PropTypes.func,
  }).isRequired,
};

VerifyPhone.defaultProps = {
  phoneNumber: undefined,
};

VerifyPhone.displayName = 'VerifyPhone';

export default VerifyPhone;
